<template>
	<div>
		<default v-if="device === 'pc'"></default>
		<TrDefault v-if="device === 'h5'"></TrDefault>
	</div>
</template>

<script>
import Default   from "@/components/default/index";
import TrDefault   from "@/components/2023default/index";
import agentUtil from "../utils/agentUtil";

export default {
	name       : "Index",
	components : { Default, TrDefault },
	metaInfo   : {
		title : "首页-寄居蟹发卡平台",
		meta  : [
			{
				name    : "keywords",
				content : "寄居蟹发卡平台-虚拟卡密寄售平台,发卡网站,自动发卡平台,发卡平台,发卡网,自动寄售平台,寄售网,虚拟寄售网,虚拟卡密交易平台,寄居蟹发卡网,寄居蟹寄售平台,寄居蟹寄售网,",
			},
			{
				name    : "description",
				content : "寄居蟹发卡平台",
			},
		],
	},
  data () {
    return {
      device:"pc"
    }
  },

	created () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      this.device='h5'
    }
	},
	mounted () {
		let ispc = agentUtil.isPC();
		if ( ispc ) {
			this.$nextTick(() => {
				// 企业QQ客服
				let oScript = document.createElement("script");//创建一个Script元素
				oScript.async   = "";
				oScript.defer   = "";
				oScript.charset = "utf-8";
				oScript.id      = "qd3009126988a13bb37e67f81072eb52d8c8e33d5adb";
				oScript.src     = "https://wp.qiye.qq.com/qidian/3009126988/a13bb37e67f81072eb52d8c8e33d5adb";//制定src属性
				// document.getElementsByTagName("head")[0].appendChild(oScript);
				document.body.appendChild(oScript);
			});
		}
	},

	methods : {},
};
</script>



// WEBPACK FOOTER //
// src/views/index.vue